// ─────────────────────────────────────────────────────────────────────────────
// sq-panel.js  —  Size & Quantity choices (inline panels)
//
// Self-contained: injects its own <style> and mounts each open list inside
// its builder row. An opened peek list shows every choice in full.
// Load before the main configurator script block.
// ─────────────────────────────────────────────────────────────────────────────

// ── 1. CSS injection ─────────────────────────────────────────────────────────
(function() {
  var s = document.createElement('style');
  s.id  = 'sq-panel-css';
  s.textContent = [
    // Trigger buttons
    '.sq-trigger{display:flex;align-items:center;font-size:14px;font-weight:600;',
    '  color:#222;background:transparent;border:none;cursor:pointer;font-family:var(--body);',
    '  padding:0 20px 0 0;',
    '  background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'7\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%23666\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E");',
    '  background-repeat:no-repeat;background-position:right 0 center;',
    '  white-space:nowrap;outline:none;text-align:right;max-width:240px}',
    '.sq-trigger:hover{color:#555}',
    // One card per field: the row and its list share a single border, so the
    // list drops open inside the card with no divider lines.
    '#sizeSelectWrap,#qtySelectWrap{border:1px solid #e5e7eb;border-radius:12px;',
    '  background:#fff;margin-bottom:8px;overflow:visible}',
    '#sizeSelectWrap > .form-row,#qtySelectWrap > .form-row{border:none;margin:0;',
    '  border-radius:0;background:transparent}',
    // Inline lists collapse in place; the builder theme holds an open peek to its closed height.
    '.sq-overlay{display:grid;grid-template-rows:0fr;opacity:0;visibility:hidden;',
    '  transition:grid-template-rows .22s ease,opacity .16s ease,visibility 0s linear .22s}',
    '.sq-overlay.open{grid-template-rows:1fr;opacity:1;visibility:visible;',
    '  transition:grid-template-rows .22s ease,opacity .18s ease .04s,visibility 0s}',
    '.sq-panel{position:relative;width:100%;min-height:0;overflow:hidden;background:transparent;',
    '  border:none;border-radius:0;margin:0;display:flex;flex-direction:column;box-shadow:none}',
    // Section padding
    '.sq-section{padding:0 10px 12px}',
    '.sq-section-label{display:none}',
    // 2-column grid — top-to-bottom (column flow via JS reorder + row grid)
    '.sq-radio-group{display:grid;grid-template-columns:1fr 1fr;gap:2px}',
    '.sq-radio-row{display:flex;align-items:center;gap:8px;padding:6px 8px;',
    '  border-radius:8px;cursor:pointer;transition:background .12s;min-width:0}',
    '.sq-radio-row:hover{background:#f6f6f6}',
    '.sq-radio-row:has(input:checked){background:#f6f6f6}',
    '.sq-radio-row:has(input:checked) .sq-radio-text{font-weight:750}',
    '.sq-radio-row input[type=radio]{width:14px;height:14px;accent-color:#059669;',
    '  cursor:pointer;flex-shrink:0;margin:0}',
    '.sq-radio-text{flex:1;font-size:12px;font-weight:600;color:#222;',
    '  white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}',
    '.sq-radio-price{font-size:11px;color:#777;white-space:nowrap;margin-left:4px}',
    '.sq-radio-save{font-size:10px;font-weight:700;color:#e63946;',
    '  margin-left:3px;white-space:nowrap}',
    // Custom size / qty: picking "Custom" swaps that cell's text for its inputs
    '.sq-custom-size,.sq-custom-qty{display:flex;align-items:center;gap:6px;min-width:0}',
    '.sq-custom-row:has(input[type=radio]:checked) > .sq-radio-text{display:none}',
    '.sq-custom-row .qty-custom-details{display:none}',
    '.sq-custom-size input[type=number],.sq-custom-qty input[type=number]{',
    '  width:56px;min-height:30px;border:1px solid #d1d5db;border-radius:6px;',
    '  padding:4px 6px;font-size:12px;font-family:var(--body);',
    '  text-align:center;outline:none;background:#fff;transition:border-color .15s;',
    '  -moz-appearance:textfield}',
    '.sq-custom-size input[type=number]::-webkit-outer-spin-button,',
    '.sq-custom-size input[type=number]::-webkit-inner-spin-button,',
    '.sq-custom-qty input[type=number]::-webkit-outer-spin-button,',
    '.sq-custom-qty input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}',
    '.sq-custom-qty input[type=number]{width:80px}',
    '.sq-custom-size input[type=number]:focus,.sq-custom-qty input[type=number]:focus{border-color:#222}',
    '.sq-dims-x{color:#999;font-size:14px;font-weight:500}',
    '.sq-dims-unit{font-size:11px;color:#9ca3af}',
    // Peek (Die Cut trial): a closed list still shows its common picks + Custom;
    // the chevron opens the rest.
    '.sq-peek .sq-overlay{grid-template-rows:1fr;opacity:1;visibility:visible}',
    '.sq-peek .sq-overlay:not(.open) .sq-radio-row:not(.sq-pick){display:none}',
    '.sq-peek .sq-overlay:not(.open) .sq-pick{order:var(--sq-peek-order,0)}',
    '@media(prefers-reduced-motion:reduce){.sq-overlay,.sq-overlay.open{transition:none}}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(s);
})();

// ── 2. HTML injection ─────────────────────────────────────────────────────────
(function() {
  var SIZE_HTML = [
    '<div class="sq-overlay" id="sqSizePopup" onclick="sqSizeOverlayClick(event)" onkeydown="sqPanelKey(event, closeSizePopup, \'sizeTrigger\')">',
    '  <div class="sq-panel" id="sqSizePanel">',
    '    <div class="sq-section">',
    '      <div class="sq-section-label">Size</div>',
    '      <div class="sq-radio-group" id="sqSizeList"></div>',
    '      <div class="sq-custom-size" id="sqCustomSize" style="display:none">',
    '        <input type="number" id="customW" data-qa="custom-width" min="0.5" max="24" step="0.25"',
    '          placeholder="W" aria-label="Width in inches" oninput="updateSizeTrigger(); updatePrice()" onchange="updatePrice()">',
    '        <span class="sq-dims-x">×</span>',
    '        <input type="number" id="customH" data-qa="custom-height" min="0.5" max="24" step="0.25"',
    '          placeholder="H" aria-label="Height in inches" oninput="updateSizeTrigger(); updatePrice()" onchange="updatePrice()">',
    '        <span class="sq-dims-unit">in</span>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n');

  var QTY_HTML = [
    '<div class="sq-overlay" id="sqQtyPopup" onclick="sqQtyOverlayClick(event)" onkeydown="sqPanelKey(event, closeQtyPopup, \'qtyTrigger\')">',
    '  <div class="sq-panel" id="sqQtyPanel">',
    '    <div class="sq-section">',
    '      <div class="sq-section-label">Quantity</div>',
    '      <div class="sq-radio-group" id="sqQtyList"></div>',
    '      <div class="sq-custom-qty" id="sqCustomQty" style="display:none">',
    '        <input type="number" id="qtyCustomInput" data-qa="qty-custom-input"',
    '          min="20" step="10" placeholder="Qty" aria-label="Custom quantity"',
    '          oninput="onQtyCustomInput()" onchange="onQtyCustomChange()">',
    '        <span class="sq-dims-unit" id="sqCustomQtyNoun"></span>',
    '        <span class="qty-custom-details" id="qtyCustomDetails"></span>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n');

  function mount(html, hostId) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var node = wrap.firstElementChild;
    var host = document.getElementById(hostId);
    if (host) host.appendChild(node);
    else document.body.appendChild(node);
  }

  function inject() {
    if (!document.getElementById('sqSizePopup')) mount(SIZE_HTML, 'sizeSelectWrap');
    if (!document.getElementById('sqQtyPopup')) mount(QTY_HTML, 'qtySelectWrap');
    sqBindRowToggle('sizeSelectWrap', openSizePopup);
    sqBindRowToggle('qtySelectWrap', openQtyPopup);
  }

  window.sqInject = inject;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();

// 10/12: INIT builds Size and Quantity with the rest of the card (it already calls buildSizeSelect/buildQtySelect, and
// switchCategory updates both triggers). The lists used to mount at DOMContentLoaded and fill at window load, so on a
// phone the rows read "Select size" for ~4 s and then slid open, growing the card. inject() is idempotent.
function sqEnsureMounted() {
  if (window.sqInject && !document.getElementById('sqSizePopup') &&
      document.getElementById('sizeSelectWrap') && document.getElementById('qtySelectWrap')) window.sqInject();
}

// ── 3. Pre-build on load — show default labels without opening panels ─────────
window.addEventListener('load', function() {
  buildSizeSelect();
  buildQtySelect();
  updateSizeTrigger();
  // Rebuild reseeds raw Sue tier prices — recompute so the trigger matches
  // the Command quote (or Sue multipliers) already painted on the page.
  if (typeof updatePrice === 'function') updatePrice();
  else updateQtyTrigger();
});

// ── 3. Helper functions ───────────────────────────────────────────────────────

function getUnitPriceForQty(qty, pricing) {
  var tiers = pricing.tiers.slice().sort(function(a,b){ return a.qty - b.qty; });
  var unit = tiers.length ? tiers[0].unitPrice : 1.30;
  for (var i = 0; i < tiers.length; i++) {
    if (qty >= tiers[i].qty) unit = tiers[i].unitPrice;
    else break;
  }
  return unit;
}

function getSelectedSizeLabel() {
  var checked = document.querySelector('#sqSizeList input[type=radio]:checked');
  return checked ? checked.value : '';
}

function getSelectedQtyValue() {
  var checked = document.querySelector('#sqQtyList input[type=radio]:checked');
  return checked ? checked.value : '';
}

function activatePill(group, value) {
  if (!group) return;
  group.querySelectorAll('input[type=radio]').forEach(function(r) {
    r.checked = r.value === String(value);
  });
}

// Reorder items for top-to-bottom column flow in a 2-column grid.
// [0,1,2,3,4,5] → [0,3,1,4,2,5] so col1=0,1,2 and col2=3,4,5
function columnOrder(arr) {
  var half = Math.ceil(arr.length / 2);
  var out  = [];
  for (var i = 0; i < half; i++) {
    out.push(arr[i]);
    if (i + half < arr.length) out.push(arr[i + half]);
  }
  return out;
}

// ── 4. Size panel builders ────────────────────────────────────────────────────

// The menus leave out 9" and 3,000 so each list is an even two-column grid
// with Custom as its last cell. Both still price through Custom.
var SQ_MENU_SKIP_SIZES = ['9x9'];
var SQ_MENU_SKIP_QTYS  = [3000];

// Stickers start at 20 (Josh 10/11: "moq lets move it down to 20 for stickers"); other products at 50.
var SQ_MENU_STICKER_CATS = ['custom-stickers', 'embossed-stickers'];

function sqMenuTiers(pricing) {
  var lowest = typeof currentCat !== 'undefined' && SQ_MENU_STICKER_CATS.indexOf(currentCat) !== -1 ? 20 : 50;
  return (pricing.tiers || []).filter(function(t) {
    return (t.qty >= 50 || t.qty === lowest) && SQ_MENU_SKIP_QTYS.indexOf(Number(t.qty)) === -1;
  });
}

// One preset size per quantity choice, plus Custom.
// Saved rows keep their label and multiplier. Missing squares are filled
// from 1" upward. Extra rows stay off the menu so the two lists match.
// Nothing here is written back to storage.
function sqSizesMatchingQty(sizes, pricing, printKind) {
  if (printKind) return sizes || [];
  var target = sqMenuTiers(pricing).length;
  if (!target) return sizes || [];
  var custom = null;
  var presets = [];
  // Roll labels only go up to 9x9 (Josh 10/31): their menu runs 1"-9" (9" in, 10" out), so every preset prices.
  var rollCap = typeof vpQuoteCut === 'function' && vpQuoteCut() === 'roll';
  function skipped(w, h) { return rollCap ? (w > 9 || h > 9) : SQ_MENU_SKIP_SIZES.indexOf(w + 'x' + h) !== -1; }
  (sizes || []).forEach(function(s) {
    if (!s || s.label === 'Custom' || s.w == null || s.h == null) {
      if (s && s.label === 'Custom') custom = s;
      return;
    }
    if (skipped(Number(s.w), Number(s.h))) return;
    presets.push(s);
  });
  function hasSquare(n) {
    return presets.some(function(s) { return Number(s.w) === n && Number(s.h) === n; });
  }
  function byArea(a, b) {
    var area = (Number(a.w) * Number(a.h)) - (Number(b.w) * Number(b.h));
    return area || (Number(a.w) - Number(b.w));
  }
  for (var n = 1; presets.length < target && n <= (rollCap ? 9 : 24); n++) {
    if (hasSquare(n) || skipped(n, n)) continue;
    var known = null;
    (pricing.sizes || []).forEach(function(s) {
      if (Number(s.w) === n && Number(s.h) === n) known = s;
    });
    presets.push(known || {
      label: n + '" \xd7 ' + n + '"',
      w: n,
      h: n,
      mult: Math.round(Math.pow((n * n) / 4, 0.30) * 1000) / 1000
    });
  }
  presets.sort(byArea);
  if (presets.length > target) {
    var seen = {};
    var squares = [];
    var extras = [];
    presets.forEach(function(s) {
      var w = Number(s.w);
      var h = Number(s.h);
      var key = w + 'x' + h;
      if (seen[key]) return;
      seen[key] = true;
      if (w >= 1 && w <= 10 && h === w && w === Math.round(w)) squares.push(s);
      else extras.push(s);
    });
    presets = squares.concat(extras).slice(0, target).sort(byArea);
  }
  if (!custom) custom = { label: 'Custom', w: null, h: null, mult: 1 };
  return presets.concat([custom]);
}

function buildSizeSelect() {
  sqEnsureMounted();
  var pricing = loadPricing();
  var printKind = typeof vpGetPrintKind === 'function' ? vpGetPrintKind() : null;
  var group   = document.getElementById('sqSizeList');
  if (!group) return;
  if (!printKind && typeof getPackagingProduct === 'function' && getPackagingProduct()) {
    group.innerHTML = '';
    return;
  }
  var sizes   = printKind && typeof vpPrintSizes === 'function' ? vpPrintSizes(printKind) : (pricing.sizes || []);
  sizes = sqSizesMatchingQty(sizes, pricing, printKind);

  var prevLabel = getSelectedSizeLabel();
  sqParkCustom('sqCustomSize', group);
  group.innerHTML = '';

  // Exclude Custom before reordering so it doesn't corrupt column layout
  var nonCustom = sizes.filter(function(s){ return s.label !== 'Custom' && s.w != null; });
  var ordered   = columnOrder(nonCustom);

  ordered.forEach(function(sz) {
    var szLabel = sz.label || '';
    // Build a pretty display label — if original is just a number, show "W″ × H″"
    var displayLabel;
    if (/^\d+(\.\d+)?$/.test(szLabel.trim())) {
      displayLabel = sz.w + '″ \xd7 ' + sz.h + '″';
    } else {
      displayLabel = szLabel;
    }

    var row   = document.createElement('label');
    row.className = 'sq-radio-row';
    var radio = document.createElement('input');
    radio.type  = 'radio';
    radio.name  = 'sqSize';
    radio.value = szLabel;           // raw sz.label — key for getSizeMult/vpGetCurrentDims
    radio.dataset.display = displayLabel; // pretty string for the trigger button
    radio.onchange = function() { onSizeChange(); };
    var text  = document.createElement('span');
    text.className = 'sq-radio-text';
    text.textContent = displayLabel;
    row.appendChild(radio);
    row.appendChild(text);
    group.appendChild(row);
  });

  var allowCustom = !printKind || printKind === 'posters' || printKind === 'banners';
  if (allowCustom) {
    var customRow = document.createElement('label');
    customRow.className = 'sq-radio-row sq-custom-row';
    var customRadio = document.createElement('input');
    customRadio.type = 'radio'; customRadio.name = 'sqSize'; customRadio.value = 'Custom';
    customRadio.onchange = function() { onSizeChange(); };
    var customText = document.createElement('span');
    customText.className = 'sq-radio-text';
    customText.textContent = 'Custom size';
    customRow.appendChild(customRadio);
    customRow.appendChild(customText);
    var customSize = document.getElementById('sqCustomSize');
    if (customSize) customRow.appendChild(customSize);
    group.appendChild(customRow);
  }

  var match = null;
  var radios = group.querySelectorAll('input[type=radio]');
  if (prevLabel) {
    radios.forEach(function(r) { if (r.value === prevLabel) match = r; });
  }
  if (!match) {
    var defaultSz = sizes.filter(function(s){ return s.default; })[0]
      || sizes.filter(function(s){ return s.w === 2 && s.h === 2; })[0];
    var defaultVal = defaultSz ? defaultSz.label : null;
    if (defaultVal) {
      radios.forEach(function(r) { if (r.value === defaultVal) match = r; });
    }
  }
  if (!match) {
    // Fallback: pick first non-Custom radio
    radios.forEach(function(r) { if (!match && r.value !== 'Custom') match = r; });
  }
  if (!match) {
    // Last resort: first radio
    radios.forEach(function(r) { if (!match) match = r; });
  }
  if (match) match.checked = true;
  onSizeChange(true);
}

// The Custom size / Custom quantity inputs live inside their own list cell.
// Rebuilding a list clears its cells, so move the inputs out first.
function sqParkCustom(id, group) {
  var box = document.getElementById(id);
  if (box && group && group.contains(box)) group.parentNode.appendChild(box);
}

function onSizeChange(silent) {
  var label    = getSelectedSizeLabel();
  var isCustom = (label === 'Custom');
  var sqCustom = document.getElementById('sqCustomSize');
  if (sqCustom) sqCustom.style.display = isCustom ? 'flex' : 'none';
  var w = document.getElementById('customW');
  if (isCustom && !silent && w && !w.value) w.focus();
  updateSizeTrigger();
  if (!silent) updatePrice();
}

// No inline error here: the note above Add to Cart says what is still missing.
function updateSizeValidation() {
  var wrap = document.getElementById('sizeSelectWrap');
  var w = document.getElementById('customW');
  var h = document.getElementById('customH');
  if (!wrap || !w || !h) return true;
  var custom = wrap.style.display !== 'none' && getSelectedSizeLabel() === 'Custom';
  var badW = custom && (!w.value || !isFinite(Number(w.value)) || Number(w.value) <= 0);
  var badH = custom && (!h.value || !isFinite(Number(h.value)) || Number(h.value) <= 0);
  if (custom && !badW && !badH && typeof vpPrintTooBig === 'function' && vpPrintTooBig(Number(w.value), Number(h.value))) {
    badW = badH = true;
  }
  w.setAttribute('aria-invalid', String(badW));
  h.setAttribute('aria-invalid', String(badH));
  return !(badW || badH);
}

function getSizeMult(pricing) {
  if (currentPackageSize) {
    var w = currentPackageSize.sideW || 2;
    var h = currentPackageSize.sideH || 2;
    return Math.pow((w * h) / 4, 0.30);
  }
  var label = getSelectedSizeLabel();
  if (label === 'Custom') {
    var wEl = document.getElementById('customW');
    var hEl = document.getElementById('customH');
    var w = parseFloat(wEl ? wEl.value : 2) || 2;
    var h = parseFloat(hEl ? hEl.value : 2) || 2;
    return Math.pow((w * h) / 4, 0.30);
  }
  for (var i = 0; i < pricing.sizes.length; i++) {
    if (pricing.sizes[i].label === label) {
      var m = pricing.sizes[i].mult;
      return (m != null) ? m : 1.0;
    }
  }
  var parsed = label && label.match(/([\d.]+)/g);
  if (parsed && parsed.length >= 2) {
    var pw = parseFloat(parsed[0]);
    var ph = parseFloat(parsed[1]);
    if (pw > 0 && ph > 0) return Math.pow((pw * ph) / 4, 0.30);
  }
  return 1.0;
}

// ── 5. Qty panel builders ─────────────────────────────────────────────────────

function sqQuantityUnit() {
  if (typeof vpQtyNoun === 'function') return vpQtyNoun(1);
  if (typeof currentChipId !== 'undefined') {
    if (currentChipId === 'yard-signs') return 'sign';
    if (currentChipId === 'banners') return 'banner';
  }
  var cat = typeof CATEGORIES !== 'undefined' && typeof currentCat !== 'undefined' ? CATEGORIES[currentCat] : null;
  return cat && cat.unit ? cat.unit : 'unit';
}

function buildQtySelect() {
  sqEnsureMounted();
  var group   = document.getElementById('sqQtyList');
  var pricing = loadPricing();
  var printKind = typeof vpGetPrintKind === 'function' ? vpGetPrintKind() : null;
  var tiers   = (pricing.tiers || []).slice().sort(function(a,b){ return a.qty - b.qty; });
  var dropTiers = printKind
    ? vpPrintQtyTiers(printKind).map(function(q){ return { qty: q, unitPrice: 0 }; })
    : sqMenuTiers({ tiers: tiers });
  if (!group) return;

  var printFirst = printKind ? String(vpPrintQtyTiers(printKind)[0]) : '50';
  var prevVal = getSelectedQtyValue() || printFirst;
  var prevCustom = document.getElementById('qtyCustomInput').value;
  var prevQty = document.getElementById('qtyInput').value;
  sqParkCustom('sqCustomQty', group);
  group.innerHTML = '';

  var baseRawUnit = getUnitPriceForQty(50, pricing);

  // Reorder for top-to-bottom column flow
  var ordered = columnOrder(dropTiers);

  ordered.forEach(function(t) {
    var savePct = (!printKind && baseRawUnit > 0) ? Math.round((baseRawUnit - t.unitPrice) / baseRawUnit * 100) : 0;
    var row   = document.createElement('label');
    row.className = 'sq-radio-row';
    var radio = document.createElement('input');
    radio.type  = 'radio';
    radio.name  = 'sqQty';
    radio.value = String(t.qty);
    radio.dataset.savePct = savePct;
    radio.onchange = function() { onQtySelect(String(t.qty)); };
    var text  = document.createElement('span');
    text.className = 'sq-radio-text';
    text.textContent = t.qty.toLocaleString() + ' ' + (typeof vpQtyNoun === 'function' ? vpQtyNoun(t.qty) : (sqQuantityUnit() + 's'));
    // Hidden price span kept for refreshQtyOptionPrices() scaling — not displayed
    var price = document.createElement('span');
    price.className = 'sq-radio-price';
    price.dataset.qty = t.qty;
    price.style.display = 'none';
    price.textContent = '$' + t.unitPrice.toFixed(2) + '/ea';
    row.appendChild(radio);
    row.appendChild(text);
    row.appendChild(price);
    if (savePct > 0) {
      var badge = document.createElement('span');
      badge.className = 'sq-radio-save';
      badge.textContent = 'save ' + savePct + '%';
      row.appendChild(badge);
    }
    group.appendChild(row);
  });

  // Custom qty — last cell of the grid
  var customRow = document.createElement('label');
  customRow.className = 'sq-radio-row sq-custom-row';
  var customRadio = document.createElement('input');
  customRadio.type = 'radio'; customRadio.name = 'sqQty'; customRadio.value = 'custom';
  customRadio.onchange = function() { onQtySelect('custom'); };
  var customText = document.createElement('span');
  customText.className = 'sq-radio-text';
  customText.textContent = 'Custom quantity';
  customRow.appendChild(customRadio);
  customRow.appendChild(customText);
  var customNoun = document.getElementById('sqCustomQtyNoun');
  if (customNoun) customNoun.textContent = typeof vpQtyNoun === 'function' ? vpQtyNoun(2) : sqQuantityUnit() + 's';
  var customQty = document.getElementById('sqCustomQty');
  if (customQty) customRow.appendChild(customQty);
  group.appendChild(customRow);

  var fallbackQty = printFirst;
  var match = group.querySelector('input[value="' + prevVal + '"]');
  if (!match) match = group.querySelector('input[value="' + fallbackQty + '"]');
  if (!match) match = group.querySelector('input[type=radio]');
  if (match) { match.checked = true; }
  onQtySelect(match ? match.value : fallbackQty, true);
  if (match && match.value === 'custom') {
    document.getElementById('qtyCustomInput').value = prevCustom;
    document.getElementById('qtyInput').value = prevQty;
    updateQtyTrigger();
    updateQtyValidation();
  }
}

function refreshQtyOptionPrices() {
  var group = document.getElementById('sqQtyList');
  if (!group) return;
  var pricing = loadPricing();
  var printKind = typeof vpGetPrintKind === 'function' ? vpGetPrintKind() : null;
  if (printKind) {
    var dims = typeof vpGetCurrentDims === 'function' ? vpGetCurrentDims() : { w: 18, h: 24 };
    var noun1 = (typeof vpQtyNoun === 'function') ? vpQtyNoun(1) : 'ea';
    var base1 = vpComputePrintTotal(printKind, dims.w, dims.h, vpPrintQtyTiers(printKind)[0]).each;
    group.querySelectorAll('.sq-radio-price[data-qty]').forEach(function(el) {
      var q = parseInt(el.dataset.qty, 10);
      var unit = vpComputePrintTotal(printKind, dims.w, dims.h, q).each;
      el.textContent = '$' + unit.toFixed(2) + '/' + noun1;
      var badge = el.parentElement.querySelector('.sq-radio-save');
      var savePct = base1 > 0 ? Math.round((base1 - unit) / base1 * 100) : 0;
      if (badge) badge.textContent = savePct > 0 ? 'save ' + savePct + '%' : '';
    });
    group.querySelectorAll('.sq-radio-text').forEach(function(el) {
      var radio = el.parentElement && el.parentElement.querySelector('input[type=radio]');
      if (!radio || radio.value === 'custom') return;
      var q = parseInt(radio.value, 10);
      if (q) el.textContent = q.toLocaleString() + ' ' + vpQtyNoun(q);
    });
    updateQtyTrigger();
    return;
  }

  // 10/12: no quote yet (Size / Quantity are built at INIT, so Quantity can be opened before the first quote):
  // keep the rows as built, with their "save" badges, instead of rescaling them from a missing price. Clearing
  // the badges shortened the open-then-closed list by ~5 px until the quote put them back.
  if (!(window._vpCurrentUnit > 0)) { updateQtyTrigger(); return; }

  // Use the unit price already computed by updatePrice() (includes size, material,
  // finish, specialty, markup) and scale proportionally across tiers.
  // Raw tier prices differ only in base unit — all other mults are identical.
  var cachedUnit = window._vpCurrentUnit || 0;
  var cachedQty  = window._vpCurrentQty  || 50;
  var rawAtCached = getUnitPriceForQty(cachedQty, pricing);
  var rawAt50     = getUnitPriceForQty(50, pricing);

  // Derive effective base-50 unit from the cached unit price
  var base50unit = (rawAtCached > 0 && cachedUnit > 0)
    ? cachedUnit * (rawAt50 / rawAtCached)
    : cachedUnit;

  group.querySelectorAll('.sq-radio-price[data-qty]').forEach(function(el) {
    var qty    = parseInt(el.dataset.qty);
    var rawTier = getUnitPriceForQty(qty, pricing);
    var unit;
    if (rawAtCached > 0 && cachedUnit > 0) {
      // Scale from cached: preserves finish/material/specialty mults exactly
      unit = cachedUnit * (rawTier / rawAtCached);
    } else {
      // Fallback: no cache yet, use raw tier price
      unit = rawTier;
    }
    el.textContent = '$' + unit.toFixed(2) + '/ea';
    var badge   = el.parentElement.querySelector('.sq-radio-save');
    var savePct = base50unit > 0 ? Math.round((base50unit - unit) / base50unit * 100) : 0;
    if (badge) badge.textContent = savePct > 0 ? 'save ' + savePct + '%' : '';
  });
  // Keep the qty trigger label in sync with the freshly computed per-unit price
  updateQtyTrigger();
}

function onQtyBackToPreset() {
  var group = document.getElementById('sqQtyList');
  var first = group ? group.querySelector('input[type=radio]:not([value=custom])') : null;
  if (first) { first.checked = true; onQtySelect(first.value); }
  var sqCustomQty = document.getElementById('sqCustomQty');
  if (sqCustomQty) sqCustomQty.style.display = 'none';
}

function onQtySelect(val, silent) {
  var qtyInput = document.getElementById('qtyInput');
  var customInput = document.getElementById('qtyCustomInput');
  var sqCustomQty = document.getElementById('sqCustomQty');
  if (sqCustomQty) sqCustomQty.style.display = val === 'custom' ? 'flex' : 'none';
  if (qtyInput) qtyInput.value = val === 'custom' ? customInput.value : val;
  if (val === 'custom' && !silent && customInput) customInput.focus();
  updateQtyTrigger();
  updateQtyValidation();
  if (!silent) updatePrice();
}

function updateQtyValidation() {
  var input = document.getElementById('qtyCustomInput');
  var details = document.getElementById('qtyCustomDetails');
  var custom = getSelectedQtyValue() === 'custom';
  var qtyInput = document.getElementById('qtyInput');
  var val = input ? Number(input.value) : 0;
  var msg = '';
  var printKind = typeof vpGetPrintKind === 'function' ? vpGetPrintKind() : null;
  var minQty = printKind ? (typeof vpPrintMinQty === 'function' ? vpPrintMinQty(printKind) : 1) : 20;
  if (custom && (!input || !input.value || !isFinite(val) || val < minQty)) msg = 'Enter a quantity of at least ' + minQty + '.';
  else if (custom && !printKind && val % 10 !== 0) msg = 'Quantity must be a multiple of 10.';
  // Preserve invalid entries; normalize valid numeric notation before parseInt-based pricing.
  if (custom && input && qtyInput) qtyInput.value = msg ? input.value : val;
  // No inline error: the note above Add to Cart says what is still missing.
  if (details && (msg || !custom)) details.textContent = '';
  if (input) input.setAttribute('aria-invalid', String(!!msg));
  return !msg;
}

function onQtyCustomInput() {
  var customInput = document.getElementById('qtyCustomInput');
  var qtyInput = document.getElementById('qtyInput');
  if (qtyInput) qtyInput.value = customInput.value;
  updateQtyTrigger();
  if (updateQtyValidation()) updatePrice();
  else if (typeof updateCartButtonState === 'function') updateCartButtonState();
}

function onQtyCustomChange() {
  onQtyCustomInput();
}

function setQty(qty) {
  var raw = qty == null ? '' : String(qty);
  var qtyInput = document.getElementById('qtyInput');
  var group = document.getElementById('sqQtyList');
  var customInput = document.getElementById('qtyCustomInput');
  var sqCustomQty = document.getElementById('sqCustomQty');
  if (!qtyInput || !group) return;
  qtyInput.value = raw;
  var match = Array.from(group.querySelectorAll('input[type="radio"]')).find(function(radio) {
    return radio.value !== 'custom' && radio.value === raw;
  });
  activatePill(group, match ? match.value : 'custom');
  if (customInput) customInput.value = match ? '' : raw;
  if (sqCustomQty) sqCustomQty.style.display = match ? 'none' : 'flex';
  updateQtyTrigger();
  updateQtyValidation();
}

function getMatMult(pricing) {
  var mat = MATERIALS[currentMat];
  if (!mat) return 1.0;
  for (var i = 0; i < pricing.materials.length; i++) {
    if (pricing.materials[i].id === mat.id) return pricing.materials[i].mult || 1.0;
  }
  return 1.0;
}

// ── 6. Panel open / close ─────────────────────────────────────────────────────

window.addEventListener('resize', function() {
  // WebKit must reflow wrapped quantity prices at the new width before the next click.
  if (typeof loadPricing === 'function') refreshQtyOptionPrices();
});

function sqSetOpen(popupId, triggerId, open) {
  var popup = document.getElementById(popupId);
  var trigger = document.getElementById(triggerId);
  if (popup) popup.classList.toggle('open', !!open);
  if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
}

// Freeze the artwork column at its closed height so a tall menu does not stretch it.
function sqPreviewLock() {
  var card = document.querySelector('.config-card');
  var left = document.querySelector('.config-left');
  if (!card || !left || card.getAttribute('data-sq-lock') === '1') return;
  left.style.minHeight = left.offsetHeight + 'px';
  left.style.alignSelf = 'start';
  // A fitted card stretches its stage to the options column; hold it too.
  var stage = left.querySelector('.product-preview');
  // Hold its height only: with the stage's square aspect-ratio a pinned
  // min-height also pins min-width, pushing the stage over the options.
  if (stage) {
    var h = stage.offsetHeight + 'px';
    stage.style.aspectRatio = 'auto';
    stage.style.height = stage.style.minHeight = h;
  }
  card.setAttribute('data-sq-lock', '1');
}

// Josh 10/09: no field or dropdown may make the preview taller. The stage is
// locked once the page has laid out and stays locked; opening lists, More,
// or embossing never unlocks it. Only a window resize or a product switch
// re-measures it, and only while every list is shut.
function sqPreviewUnlock() {}

function sqStageAnyOpen() {
  var ids = ['sqSizePopup', 'sqQtyPopup'];
  for (var i = 0; i < ids.length; i++) {
    var el = document.getElementById(ids[i]);
    if (el && el.classList.contains('open')) return true;
  }
  var lam = document.getElementById('finishSection');
  var instr = document.getElementById('instrAccordion');
  return !!((lam && lam.classList.contains('lam-open')) || (instr && instr.classList.contains('open')));
}

function sqStageRelock() {
  if (sqStageAnyOpen()) return;
  var card = document.querySelector('.config-card');
  var left = document.querySelector('.config-left');
  if (!card || !left) return;
  card.removeAttribute('data-sq-lock');
  left.style.minHeight = '';
  left.style.alignSelf = '';
  var stage = left.querySelector('.product-preview');
  if (stage) stage.style.minHeight = stage.style.height = stage.style.aspectRatio = '';
  requestAnimationFrame(function() { requestAnimationFrame(sqPreviewLock); });
}

window.addEventListener('load', function() {
  setTimeout(sqStageRelock, 300);
  var t = null;
  window.addEventListener('resize', function() {
    clearTimeout(t);
    t = setTimeout(sqStageRelock, 200);
  });
  if (typeof switchCategory === 'function') {
    var origSwitch = switchCategory;
    switchCategory = function() {
      var r = origSwitch.apply(this, arguments);
      setTimeout(sqStageRelock, 300);
      return r;
    };
  }
});

// ── 6b. Click to toggle ───────────────────────────────────────────────────────
// Clicking the Size or Quantity row opens its list; clicking it again closes
// it. Hovering never opens a list. Only one full list opens at a time,
// and picking a choice leaves it open so shoppers can
// click through sizes and quantities and watch the price move.
function sqBindRowToggle(wrapId, toggle) {
  var wrap = document.getElementById(wrapId);
  if (!wrap || wrap.__sqToggleBound) return;
  wrap.__sqToggleBound = true;
  // The whole row is the toggle, not just the value on the right.
  var row = wrap.querySelector('.form-row');
  if (!row) return;
  row.style.cursor = 'pointer';
  row.addEventListener('click', function(e) {
    if (!e.target.closest('.sq-trigger')) toggle();
  });
}

// Enter keeps the highlighted choice and closes; Escape closes.
function sqPanelKey(e, close, triggerId) {
  if (e.key !== 'Enter' && e.key !== 'Escape') return;
  if (e.target && e.target.tagName === 'BUTTON') return;
  e.preventDefault();
  close();
  var trigger = document.getElementById(triggerId);
  if (trigger) trigger.focus();
}

function openSizePopup() {
  var popup = document.getElementById('sqSizePopup');
  if (popup && popup.classList.contains('open')) {
    closeSizePopup();
    return;
  }
  sqPreviewLock();
  // One thing open at a time: fold the other list and the laminate list.
  if (document.querySelector('#sqQtyPopup.open')) closeQtyPopup();
  if (typeof setLaminateMore === 'function' && document.querySelector('#finishSection.lam-open')) setLaminateMore(false);

  var sizeList = document.getElementById('sqSizeList');
  if (sizeList && sizeList.children.length === 0) buildSizeSelect();

  sqSetOpen('sqSizePopup', 'sizeTrigger', true);
  var panel = document.getElementById('sqSizePanel');
  if (panel) panel.scrollTop = 0;
  updatePrice();
}

function closeSizePopup() {
  sqSetOpen('sqSizePopup', 'sizeTrigger', false);
  updateSizeTrigger();
  updatePrice();
  sqPreviewUnlock();
}

function sqSizeOverlayClick(e) {
  if (e.target && e.target.id === 'sqSizePopup') closeSizePopup();
}

function openQtyPopup() {
  var popup = document.getElementById('sqQtyPopup');
  if (popup && popup.classList.contains('open')) {
    closeQtyPopup();
    return;
  }
  sqPreviewLock();
  // One thing open at a time: fold the other list and the laminate list.
  if (document.querySelector('#sqSizePopup.open')) closeSizePopup();
  if (typeof setLaminateMore === 'function' && document.querySelector('#finishSection.lam-open')) setLaminateMore(false);

  var qtyList = document.getElementById('sqQtyList');
  if (qtyList && qtyList.children.length === 0) buildQtySelect();
  refreshQtyOptionPrices();

  sqSetOpen('sqQtyPopup', 'qtyTrigger', true);
  var panel = document.getElementById('sqQtyPanel');
  if (panel) panel.scrollTop = 0;
  updatePrice();
}

function closeQtyPopup() {
  sqSetOpen('sqQtyPopup', 'qtyTrigger', false);
  updateQtyTrigger();
  updatePrice();
  sqPreviewUnlock();
}

function sqQtyOverlayClick(e) {
  if (e.target && e.target.id === 'sqQtyPopup') closeQtyPopup();
}

// Legacy alias — called from configurator.html chip switch and cart validation
function openSizeQtyPopup(which) {
  if (which === 'qty') { openQtyPopup(); } else { openSizePopup(); }
}
function closeSizeQtyPopup() {
  closeSizePopup();
  closeQtyPopup();
}

// ── 7b. Peek lists (Die Cut trial 10/09, every sticker + label page 10/10) ───
// Closed lists keep their common choices plus Custom showing: Size two rows,
// Quantity three. A choice made from the full list takes the last spot once it closes.
// Posters/banners keep plain lists; their sizes and quantities differ.
var SQ_PEEK_CATS = ['custom-stickers', 'embossed-stickers', 'labels'];
var SQ_PEEK_SIZES = ['2" \xd7 2"', '3" \xd7 3"', '4" \xd7 4"'];
var SQ_PEEK_QTYS  = ['50', '100', '200', '500', '1000'];

function sqMarkPicks(wrapId, listId, popupId, picks, keyOf) {
  var wrap = document.getElementById(wrapId);
  var list = document.getElementById(listId);
  if (!wrap || !list) return;
  var on = typeof currentCat !== 'undefined' && SQ_PEEK_CATS.indexOf(currentCat) !== -1;
  wrap.classList.toggle('sq-peek', on);
  if (!on) return;
  var popup = document.getElementById(popupId);
  if (popup && popup.classList.contains('open')) return;  // never reshuffle an open list
  var radios = Array.prototype.slice.call(list.querySelectorAll('input[type=radio]'));
  var keys = picks.slice();
  var checked = radios.filter(function(r) { return r.checked; })[0];
  var checkedKey = checked ? keyOf(checked) : null;
  if (checked && checked.value.toLowerCase() !== 'custom' && keys.indexOf(checkedKey) === -1) keys[keys.length - 1] = checkedKey;
  radios.forEach(function(r) {
    var pick = r.value.toLowerCase() === 'custom' || keys.indexOf(keyOf(r)) !== -1;
    var row = r.closest('.sq-radio-row');
    row.classList.toggle('sq-pick', pick);
    // Closed, the picks read smallest to largest with Custom last.
    var n = parseFloat(r.value);
    row.style.setProperty('--sq-peek-order', String(isNaN(n) ? 999999 : n));
  });
}

function sqMarkSizePicks() {
  sqMarkPicks('sizeSelectWrap', 'sqSizeList', 'sqSizePopup', SQ_PEEK_SIZES,
    function(r) { return r.dataset.display || r.value; });
}

function sqMarkQtyPicks() {
  sqMarkPicks('qtySelectWrap', 'sqQtyList', 'sqQtyPopup', SQ_PEEK_QTYS,
    function(r) { return r.value; });
}

// ── 8. Trigger button labels ──────────────────────────────────────────────────

function updateSizeTrigger() {
  sqMarkSizePicks();
  var btn = document.getElementById('sizeTrigger');
  if (!btn) return;
  var label = getSelectedSizeLabel();
  if (label === 'Custom') {
    var wEl = document.getElementById('customW');
    var hEl = document.getElementById('customH');
    var w = wEl ? wEl.value : '';
    var h = hEl ? hEl.value : '';
    btn.textContent = (w && h) ? w + '" \xd7 ' + h + '" (custom)' : 'Custom size';
  } else {
    // Use the pretty display label stored on the radio, fall back to raw value
    var checked = document.querySelector('#sqSizeList input[type=radio]:checked');
    btn.textContent = (checked && checked.dataset.display) ? checked.dataset.display : (label || 'Select size');
  }
}

function updateQtyTrigger() {
  sqMarkQtyPicks();
  var btn = document.getElementById('qtyTrigger');
  if (!btn) return;
  var val = getSelectedQtyValue();
  if (val === 'custom') {
    var ci  = document.getElementById('qtyCustomInput');
    var qty = ci ? ci.value : '';
    btn.textContent = qty ? qty + ' (custom)' : 'Custom quantity';
  } else if (val) {
    var priceEl = document.querySelector('#sqQtyList .sq-radio-price[data-qty="' + val + '"]');
    // 10/12: the per-sticker price only once the real quote is in (window._vpCurrentUnit, set by vpPaintPrice);
    // before it the hidden row prices are Sue's raw tiers. Until then the row reads "50 stickers".
    var price   = (priceEl && window._vpCurrentUnit) ? '  \xb7  ' + priceEl.textContent : '';
    var n = parseInt(val, 10);
    var noun = (typeof vpQtyNoun === 'function') ? vpQtyNoun(n) : (sqQuantityUnit() + 's');
    btn.textContent = n.toLocaleString() + ' ' + noun + price;
  } else {
    btn.textContent = 'Select quantity';
  }
}
